import React from 'react';
import { Button } from 'semantic-ui-react';

const MediaActions = ({ types, id, disabled, externalLink }) => (
  <>
    {types.video ? (
      <Button
        disabled={disabled}
        icon="circle play"
        className="link"
        href={`https://www.twr360.org/programs/view/id,${id}/action,video`}
      />
    ) : null}
    {types.audio ? (
      <Button
        disabled={disabled}
        icon="volume up"
        className="link"
        href={`https://www.twr360.org/programs/view/id,${id}/action,audio`}
      />
    ) : null}
    {types.pdf ? (
      <Button
        disabled={disabled}
        icon="book"
        className="link"
        href={`https://www.twr360.org/programs/view/id,${id}`}
      />
    ) : null}
    {types.link ? (
      <Button
        disabled={disabled}
        icon="external"
        className="link"
        href={externalLink}
      />
    ) : null}
  </>
);

export default MediaActions;
